import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import { handleApiError } from "../../Helpers/handleApiError ";
import Swal from "sweetalert2";

const getToken = () => localStorage.getItem("u_token");

// Fetch log

export const fetchLogDetail = createAsyncThunk(
  "log/fetchLogDetail",
  async ({ search, page, rowsPerPage, month, year, sort_by, sort_order, roleId, user, onlineOnly }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/log/details?search=${search}&page=${page + 1
        }&limit=${rowsPerPage}&month=${month || ""}&year=${year || ""}&sort_by=${sort_by}&sort_order=${sort_order}&role=${roleId}&user=${user}&onlineOnly=${onlineOnly}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch logs." }
      );
    }
  }
);
export const fetchLog = createAsyncThunk(
  "log/fetchLog",
  async ({ search, page, rowsPerPage, month, year, sort_by, sort_order, roleId, user, from, to }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/log?search=${search}&page=${page + 1
        }&limit=${rowsPerPage}&month=${month || ""}&year=${year || ""}&sort_by=${sort_by}&sort_order=${sort_order}&role=${roleId}&user=${user}&from=${from}&to=${to}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch logs." }
      );
    }
  }
);
export const fetchDeviceLog = createAsyncThunk(
  "log/fetchDeviceLog",
  async ({ search, page, rowsPerPage, month, year }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(
        `${Apiurl}admin/device?search=${search}&page=${page + 1
        }&limit=${rowsPerPage}&month=${month || ""}&year=${year || ""}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch logs." }
      );
    }
  }
);

const initialState = {
  logData: [],
  logDetail: [],
  deviceLog:[],
  userOptions: [],
  count: 0,
  loading: false,
  status: "idle",
  deleteStatus: "idle",
  error: null,
};

const logSlice = createSlice({
  name: "log",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLogDetail.pending, (state) => {
        state.error = null;
        state.status = "pending";
      })
      .addCase(fetchLogDetail.fulfilled, (state, action) => {
        state.logDetail = action.payload.data;
        state.count = action.payload.total;
        state.userOptions = action.payload.allUser;
        state.status = "succeeded";
      })
      .addCase(fetchLogDetail.rejected, (state, action) => {
        state.error = action.payload;
        state.status = "failed";
      })
      .addCase(fetchLog.pending, (state) => {
        state.error = null;
        state.status = "pending";
      })
      .addCase(fetchLog.fulfilled, (state, action) => {
        state.logData = action.payload.data;
        state.count = action.payload.total;
        state.userOptions = action.payload.allUser;
        state.status = "succeeded";
      })
      .addCase(fetchLog.rejected, (state, action) => {
        state.error = action.payload;
        state.status = "failed";
      })
      .addCase(fetchDeviceLog.pending, (state) => {
        state.error = null;
        state.status = "pending";
      })
      .addCase(fetchDeviceLog.fulfilled, (state, action) => {
        state.deviceLog = action.payload.data;
        state.count = action.payload.total;
        state.status = "succeeded";
      })
      .addCase(fetchDeviceLog.rejected, (state, action) => {
        state.error = action.payload;
        state.status = "failed";
      });
  },
});

export default logSlice.reducer;
